import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import StyledInput from '../../custom/StyledInput';
import StepButton from '../StepButton';
import { personaActions, selectPersonaEmail } from '../../../app/slices/persona.slice';
import { emailAPI } from '../../../services/EmailService';
import TextCustomization from '../../customizations/TextCustomization';
import { CustomizationKey } from '../../../app/slices/customizations.slice';
import { Header } from './Header';
import { BlankCheckEmailInputConsentCustomization } from '../../customizations/BlankCheckEmailInputCustomizations';
import { handleError } from '../../../app/slices/errors.slice';
import { changeStep } from '../../../app/slices/step.slice';
import { useAppTranslation } from '../../../i18n';
import { z } from 'zod';

const BLANK_CHECK_EMAIL_INPUT_PAGE_TITLE_KEY: CustomizationKey = 'BLANK_CHECK_EMAIL_INPUT_PAGE_TITLE';
const BLANK_CHECK_EMAIL_INPUT_PAGE_SUBTITLE_KEY: CustomizationKey = 'BLANK_CHECK_EMAIL_INPUT_PAGE_SUBTITLE';

const EmailSchema = z.string().email();

const BlankCheckInputStep = () => {
	const dispatch = useAppDispatch();
	const { t } = useAppTranslation();

	const providedEmail = useAppSelector(selectPersonaEmail);
	const [email, setEmail] = useState<string>(providedEmail || '');

	const handleChangeEmail = (email: string) => {
		setEmail(email);
	};

	const handleSubmit = async (): Promise<void> => {
		try {
			await emailAPI.sendEmailAddress(email);
			dispatch(changeStep('EMAIL_VERIFICATION_PENDING_STEP'));
			dispatch(personaActions.setPersonaEmail(email));
		} catch (error) {
			handleError(error);
		}
	};

	const isSubmitButtonDisabled = !isEmailValid(email);

	const placeholder = t(`email-page.email-address-placeholder`);
	return (
		<React.Fragment>
			<Header />
			<div id="email-input-step" className="email-step">
				<br />
				<br />
				<div className="email-step-title-style">
					<TextCustomization id={BLANK_CHECK_EMAIL_INPUT_PAGE_TITLE_KEY} />
				</div>
				<br />
				<div className="email-step-sub-title-style">
					{' '}
					<TextCustomization id={BLANK_CHECK_EMAIL_INPUT_PAGE_SUBTITLE_KEY} />
				</div>
				<StyledInput id="email" value={email} placeholder={placeholder} onChange={handleChangeEmail} />
				<div>
					<br />
					<div className="final-step-award-text">
						<BlankCheckEmailInputConsentCustomization />
						<br />
						<br />
					</div>
				</div>
				<StepButton
					disabled={isSubmitButtonDisabled}
					className={`${isSubmitButtonDisabled && 'disabled-next-button'}`}
					onClick={() => handleSubmit()}
					title={t(`email-page.continue-button-text`)}
				/>
			</div>
		</React.Fragment>
	);
};

export default BlankCheckInputStep;

const isEmailValid = (email: string): boolean => {
	return EmailSchema.safeParse(email).success;
};
